import { 
  getAuth, 
  RecaptchaVerifier, 
  signInWithPhoneNumber, 
  ConfirmationResult, 
  signInWithCredential, 
  PhoneAuthProvider 
} from "firebase/auth";

declare global {
  interface Window {
    recaptchaVerifier: RecaptchaVerifier;
    confirmationResult: ConfirmationResult;
  }
}

const setupRecaptcha  = (auth: any, containerId: string) => {
  const recaptchaVerifier = new RecaptchaVerifier(auth, containerId, {
    'size': 'invisible',
    'callback': () => {
      console.log("reCAPTCHA solved!");
    }
  });

  recaptchaVerifier.render();
  return recaptchaVerifier;
};

const sendVerificationCode = (phoneNumber: string, recaptchaVerifier: any): Promise<ConfirmationResult> => {
  const auth = getAuth();
  return signInWithPhoneNumber(auth, phoneNumber, recaptchaVerifier);
};

const verifyCode = async (verificationId: string, code: string) => {
  const auth = getAuth();
  const credential = PhoneAuthProvider.credential(verificationId, code);
  const userCredential = await signInWithCredential(auth, credential);
  const idToken = await userCredential.user.getIdToken();
  return idToken;
};

export { setupRecaptcha, sendVerificationCode, verifyCode };